<template>
  <div>
    <modal
        height="auto"
        :scrollable=true
        name="contact-form"
        :adaptive=true
        :width="700"
        class="contact-form-modal">
      <div class="modal-content">
        <div class="modal-contact-form-header">
          <a href="#" @click.prevent="closeFormModal" class="close-but">
            <img class="d-sm-inline" src="/img/icon-cross-dark.svg" alt="">
          </a>
          <div class="row">
            <div class="col-12">
              <title-widget class="text-center">{{ $t(locale.contacts.hasProject) }}</title-widget>
              <div class="form-text text-center">{{ $t(locale.contacts.formText) }}</div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="contact-form-wrapper">
                <form action="" method="post" class="contact-form" @submit.prevent="submit" id="contact_form">
                  <input type="text"
                         name="user_name"
                         id="user_name"
                         :placeholder="$t(locale.contacts.fields.name.placeholder)"
                         class="w-100"
                         :class="{ 'w-error': $v.user_name.$error }"
                         v-model.trim="$v.user_name.$model"/>
                  <div class="inputs-space">
                    <span class="form-error" v-if="!$v.user_name.required">{{
                        $t(locale.contacts.fields.name.required)
                      }}</span>
                  </div>
                  <input type="email"
                         name="user_email"
                         id="user_email"
                         :placeholder="$t(locale.contacts.fields.email.placeholder)"
                         class="w-100"
                         :class="{ 'w-error': $v.user_email.$error }"
                         v-model.trim="$v.user_email.$model"/>
                  <div class="inputs-space">
                    <span class="form-error" v-if="!$v.user_email.required">{{
                        $t(locale.contacts.fields.email.required)
                      }}</span>
                    <span class="form-error" v-if="!$v.user_email.email">{{
                        $t(locale.contacts.fields.email.error)
                      }}</span>
                  </div>
                  <input type="text"
                         name="user_phone"
                         id="user_phone"
                         :placeholder="$t(locale.contacts.fields.phone.placeholder)"
                         class="w-100"
                         :class="{ 'w-error': $v.user_phone.$error }"
                         v-model.trim="$v.user_phone.$model"/>
                  <div class="inputs-space">
                    <span class="form-error" v-if="!$v.user_phone.required">{{
                        $t(locale.contacts.fields.phone.required)
                      }}</span>
                    <span class="form-error" v-if="!$v.user_phone.numeric">{{
                        $t(locale.contacts.fields.phone.error)
                      }}</span>
                  </div>
                  <textarea name="user_message"
                            id="user_message"
                            cols="30"
                            rows="10"
                            :placeholder="$t(locale.contacts.fields.message.placeholder)"
                            class="w-100"/>
                  <div class="d-flex user-agree-wrapper align-content-center mt-4">
                    <input :class="{ 'w-error': $v.checky.$error }"
                           v-model.trim="checky"
                           @change="$v.checky.$touch()"
                           type="checkbox"
                           name="user_agree"
                           id="user_agree"
                           value="1"/>
                    <label class="ml-5" for="user_agree">{{ $t(locale.contacts.privacy.text) }}</label>
                    &nbsp;<a class="d-none d-sm-inline" href="#"
                             @click.prevent="openConfidentialModal">{{ $t(locale.contacts.privacy.link) }}</a>
                  </div>
                  <a href="#" class="ml-5 d-inline d-sm-none"
                     @click.prevent="openConfidentialModal">{{ $t(locale.contacts.privacy.link) }}</a>
                  <input type="submit" :value="$t(locale.contacts.send)"
                         class="mt-4 mt-lg-5 text-center w-100 pl-0 pr-0"
                         onsubmit="ym(56244529, 'reach-Goal', 'FILL-IN'); return true;">
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal height="auto" class="screen-9-modal" name="success">
      <img class="d-block m-auto" src="/img/icon-ok.svg" :alt="$t(locale.contacts.applySuccess)">
      <p class="text-center ml-auto mr-auto mt-3">
        {{ $t(locale.contacts.applySuccess) }}
      </p>
    </modal>
    <modal height="auto"
           :scrollable=true
           name="confidential-form"
           :adaptive=true
           :class="'confidential-modal'"
    >
      <div class="modal-content">
        <div class="modal-black-header">
          <a href="#" @click="closeConfidentialModal" class="">
            <img class="d-inline" src="/img/icon-cross-dark.svg" alt="">
          </a>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12" v-html="$t(locale.policy.content)"/>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import App from "../../App";
import TitleWidget from "@/components/common/TitleWidget";
import stringsKeys from "../../i18n/strings.json";
import $ from 'jquery';
import {email, numeric, required} from "vuelidate/lib/validators";

export default {
  name: "ContactModalForm",
  components: {TitleWidget},
  data: () => {
    return {
      locale: stringsKeys,
      screenSettings: {
        address: App.data().globalSettings.address,
        phoneLink: App.data().globalSettings.phone.link,
        phoneText: App.data().globalSettings.phone.text,
        mail: App.data().globalSettings.email,
      },
      user_name: '',
      user_email: '',
      user_phone: '',
      submitStatus: null,
      checky: '',
    }
  },
  validations: {
    user_name: {
      required,
    },
    user_phone: {
      required,
      numeric
    },
    user_email: {
      required,
      email
    },
    checky: {
      required(val) {
        return val
      }
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.console.log('invalid');
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'PENDING';
        var fd = new FormData(document.getElementById("contact_form"));
        var _this = this;
        $.ajax({
          type: 'post',
          url: '/ajax/mail.php',
          data: fd,
          processData: false,
          contentType: false,
          success: function () {
            _this.submitStatus = 'OK';
            $("#contact_form input[type='text'], #contact_form input[type='email'], #contact_form textarea").val("");
            $("#contact_form input[type='checkbox']").prop("checked", false);
            $("#contact_form input[type='submit']").prop("disabled", true).addClass("disabled");
            setTimeout(function () {
              $("#contact_form input[type='submit']").prop("disabled", false).removeClass("disabled");
            }, 10000)
            _this.$modal.hide('contact-form');
            _this.$modal.show('success')
          }
        });
      }
    },
    closeFormModal() {
      this.$modal.hide('contact-form');
    },
    openConfidentialModal() {
      this.$modal.show('confidential-form');
    },
    closeConfidentialModal() {
      this.$modal.hide('confidential-form');
    }
  }
}
</script>

<style lang="scss">
@import "../../scss/colors";
@import "../../scss/buttons";

.contact-form-modal {
  .v--modal {
    transform: scale(0.91);
  }
  .modal-contact-form-header {
    margin-top: 10px;
    .close-but {
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 99;

      img {
        width: 27px;
      }
    }
    .form-text {
      font-size: 34px;
      font-weight: normal;
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
  }

  .contact-form-wrapper {
    .contact-form {
      margin: 10px;
      @media (min-width: 576px) {
        margin: 40px;
      }

      .inputs-space {
        min-height: 20px;
        @media (min-width: 992px) {
          min-height: 40px;
        }
      }

      input[type='text'], input[type='email'] {
        height: 54px;
        display: flex;
        align-content: center;
        border: 1px solid #C4C4C4;
        padding-left: 10px;
        font-family: "Circe", sans-serif;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        outline: none;
        color: #303030;

        &.w-error {
          border-color: #E15554;
        }

        &::placeholder {
          color: #8E8F9B;
        }

        &:focus {
          border-color: #00D665;
        }

        &.w-error {
          & + .inputs-space {
            .form-error {
              display: inline;
            }
          }
        }
      }

      textarea {
        border: 1px solid #C4C4C4;
        padding-left: 10px;
        padding-top: 20px;
        font-family: "Circe", sans-serif;
        font-weight: normal;
        height: 107px;
        outline: none;
        color: #303030;

        &::placeholder {
          color: #8E8F9B;
        }

        &:focus {
          border-color: #00D665;
        }
      }

      .form-error {
        font-family: 'Circe', sans-serif;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: #E15554;
        display: none;
      }

      input[type='checkbox'] {
        width: 1px;
        height: 1px;
        visibility: hidden;
        z-index: 10;

        &:after {
          content: ' ';
          display: inline-block;
          visibility: visible;
          width: 23px;
          height: 23px;
          border: 2px solid #C4C4C4;
        }

        &:checked {
          &:after {
            background-repeat: no-repeat;
            background-size: contain;
            background-image: url('/img/icon-checked.svg');
            background-position: center;
          }
        }

        &.w-error {
          &:after {
            border-color: #E15554;;
          }

        }
      }

      input[type='submit'] {
        @extend .standard-button;
        outline: none;
        border-color: #00D665;
        color: #00D665;
        transition: all .3s;
        height: 50px;
        border-radius: 0 !important;

        &:hover, &:active {
          background-color: #00D665;
          transition: all .3s;
        }

        &.disabled {
          border-color: $gray;
          color: $gray;

          &:hover, &:active {
            background-color: transparent;
            color: $gray;
          }
        }
      }

      .user-agree-wrapper {

        max-width: 288px;
        @media (min-width: 576px) {
          max-width: none;
        }

        a {
          font-family: "Circe", sans-serif;
          color: $black;
          font-size: 14px;
          line-height: 21px;
          font-weight: bold;
          text-decoration: underline;

          &:hover {
            text-decoration: none;
          }
        }

        label {
          font-family: "Circe", sans-serif;
          font-weight: normal;
          font-size: 14px;
          line-height: 23px;
          margin-bottom: -10px;
          z-index: 10;
        }

        & + a {
          font-family: "Circe", sans-serif;
          color: $black;
          font-size: 14px;
          line-height: 21px;
          font-weight: bold;
          text-decoration: underline;

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}
.confidential-modal {
  .v--modal {
    margin: auto !important;
    left: auto !important;
    right: auto !important;
    top: auto !important;;
    bottom: auto !important;
    width: 100% !important;
    max-width: 890px;
    padding-bottom: 60px !important;

    .modal-content {
      border: none !important;
    }

    @media (min-width: 768px) {
      max-width: 600px;
    }

    h3 {
      font-size: 14px;
      font-weight: bold;
    }

    .modal-black-header {
      width: 100%;
      padding-top: 43px;
      padding-bottom: 43px;
      background-color: transparent;
      text-align: right;
      padding-right: 21px;
      @media (min-width: 576px) {
        padding-top: 25px;
        padding-bottom: 41px;
        background-color: transparent;
      }
      @media (min-width: 768px) {
        padding-top: 25px;
        padding-bottom: 21px;
      }
      @media (min-width: 992px) {
        padding-top: 10px;
        padding-bottom: 0;
      }
    }
  }

  ol {
    padding-left: .5rem !important;

    ol {
      padding-left: 1rem;
    }

    &.text-block {
      font-size: 14px;
    }
  }
}
</style>